import { FilterDomains, ConnectionsOperatorTypes, Filter } from 'app/components/filters/types';
import { postfixOperator } from 'app/components/filters/filters-panel/constants';
import { EditingValues } from 'app/components/filters/filters-panel/types';
import { FavouriteConnections } from 'app/types-shared';

export function mapConnections(currentList: Filter[],
  editingValues: EditingValues,
  templateConnections: FavouriteConnections[]
): FavouriteConnections[] {
  const predefinedFilter = currentList.find(item => item.domain === FilterDomains.PredefFilters);

  const predefinedFilterId = predefinedFilter && predefinedFilter.id;
  const predefinedFilterInclude = predefinedFilterId && (predefinedFilterId + postfixOperator.include);
  const predefinedFilterExclude = predefinedFilterId && (predefinedFilterId + postfixOperator.exclude);

  const editingValuesInclude = editingValues && predefinedFilterInclude && editingValues[predefinedFilterInclude];
  const editingValuesExclude = editingValues && predefinedFilterExclude && editingValues[predefinedFilterExclude];

  const includeValues = (editingValuesInclude && editingValuesInclude.value) || [];
  const excludeValues = (editingValuesExclude && editingValuesExclude.value) || [];

  return [
    ...templateConnections.filter(c =>
      c.operator.v !== ConnectionsOperatorTypes.include && c.operator.v !== ConnectionsOperatorTypes.exclude),

    ...(includeValues.map(item => ({
      connected: { v: item.value },
      operator: { v: ConnectionsOperatorTypes.include }
    }))),

    ...(excludeValues.map(item => ({
      connected: { v: item.value },
      operator: { v: ConnectionsOperatorTypes.exclude }
    })))
  ];
}
